import { render, staticRenderFns } from "./FileDropField.vue?vue&type=template&id=cbcc550a&scoped=true&"
import script from "./FileDropField.vue?vue&type=script&lang=js&"
export * from "./FileDropField.vue?vue&type=script&lang=js&"
import style0 from "./FileDropField.vue?vue&type=style&index=0&id=cbcc550a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbcc550a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VInput } from 'vuetify/lib/components/VInput';
installComponents(component, {VIcon,VInput})
